import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

import PeopleIcon from '@mui/icons-material/People';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import ForumIcon from '@mui/icons-material/Forum';
import PublicIcon from '@mui/icons-material/Public';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import PolicyIcon from '@mui/icons-material/Policy';
import TuneIcon from '@mui/icons-material/Tune';
import ArticleIcon from '@mui/icons-material/Article';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddIcon from '@mui/icons-material/Add';
import DataObjectIcon from '@mui/icons-material/DataObject';
import InfoIcon from '@mui/icons-material/Info';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PasswordIcon from '@mui/icons-material/Password';
import GoogleIcon from '@mui/icons-material/Google';
import PersonIcon from '@mui/icons-material/Person';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import GroupIcon from '@mui/icons-material/Group';
import GroupsIcon from '@mui/icons-material/Groups';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BusinessIcon from '@mui/icons-material/Business';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import DownloadIcon from '@mui/icons-material/Download';
import SelectAll from '@mui/icons-material/SelectAll';
import LinkIcon from '@mui/icons-material/Link';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import LockClockIcon from '@mui/icons-material/LockClock';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CallMadeIcon from '@mui/icons-material/CallMade';
import ImageIcon from '@mui/icons-material/Image';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ApartmentIcon from '@mui/icons-material/Apartment';
import DownloadingIcon from '@mui/icons-material/Downloading';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MailLockIcon from '@mui/icons-material/MailLock';
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';
import BadgeIcon from '@mui/icons-material/Badge';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export type IconType =
  | 'people'
  | 'supervisor'
  | 'person'
  | 'bar-chart'
  | 'layers'
  | 'chevron-left'
  | 'chevron-right'
  | 'expand'
  | 'collapse'
  | 'menu'
  | 'notifs'
  | 'lock'
  | 'log-out'
  | 'chat'
  | 'globe'
  | 'enterprise'
  | 'policy'
  | 'tune'
  | 'article'
  | 'close'
  | 'search'
  | 'menu-arrow'
  | 'refresh'
  | 'plus-circle'
  | 'plus'
  | 'json'
  | 'info-circle'
  | 'arrow-right'
  | 'arrow-left'
  | 'text-file'
  | 'edit'
  | 'google'
  | 'password'
  | 'delete'
  | 'copy'
  | 'save'
  | 'cancel'
  | 'group'
  | 'groups'
  | 'lock-person'
  | 'model-training'
  | 'check-circle'
  | 'check'
  | 'more-vert'
  | 'organization'
  | 'network-error'
  | 'deny'
  | 'download'
  | 'link'
  | 'assignment'
  | 'time-lapse'
  | 'lock-clock'
  | 'doc-search'
  | 'select-all'
  | 'question-mark'
  | 'arrow-double-up'
  | 'arrow-double-down'
  | 'upload'
  | 'image'
  | 'vector'
  | 'cloudsync'
  | 'assume-role'
  | 'receipt'
  | 'partner'
  | 'export'
  | 'more-horiz'
  | 'magic-link'
  | 'plug'
  | 'certificate'
  | 'open-in-new'
  | 'unlock'
  | 'visibility'
  | 'visibility-off';

type IconElementType = OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
  muiName: string;
};

export const IconMap: Map<IconType, IconElementType> = new Map();
IconMap.set('people', PeopleIcon);
IconMap.set('supervisor', SupervisedUserCircleIcon);
IconMap.set('person', PersonIcon);
IconMap.set('bar-chart', BarChartIcon);
IconMap.set('layers', LayersIcon);
IconMap.set('chevron-left', ChevronLeftIcon);
IconMap.set('chevron-right', ChevronRightIcon);
IconMap.set('menu', MenuIcon);
IconMap.set('notifs', NotificationsIcon);
IconMap.set('lock', LockOutlinedIcon);
IconMap.set('unlock', LockOpenIcon);
IconMap.set('visibility', VisibilityIcon);
IconMap.set('visibility-off', VisibilityOffIcon);
IconMap.set('log-out', LogoutOutlined);
IconMap.set('chat', ForumIcon);
IconMap.set('globe', PublicIcon);
IconMap.set('enterprise', CorporateFareIcon);
IconMap.set('policy', PolicyIcon);
IconMap.set('tune', TuneIcon);
IconMap.set('article', ArticleIcon);
IconMap.set('close', CloseIcon);
IconMap.set('search', SearchIcon);
IconMap.set('menu-arrow', ArrowDropDownIcon);
IconMap.set('refresh', RefreshIcon);
IconMap.set('plus-circle', AddCircleIcon);
IconMap.set('plus', AddIcon);
IconMap.set('json', DataObjectIcon);
IconMap.set('info-circle', InfoIcon);
IconMap.set('arrow-right', ArrowForwardIcon);
IconMap.set('arrow-left', ArrowBackIcon);
IconMap.set('text-file', TextSnippetIcon);
IconMap.set('edit', EditNoteIcon);
IconMap.set('google', GoogleIcon);
IconMap.set('password', PasswordIcon);
IconMap.set('delete', RemoveCircleIcon);
IconMap.set('copy', ContentCopyIcon);
IconMap.set('save', SaveIcon);
IconMap.set('cancel', CancelIcon);
IconMap.set('group', GroupIcon);
IconMap.set('groups', GroupsIcon);
IconMap.set('lock-person', LockPersonIcon);
IconMap.set('model-training', ModelTrainingIcon);
IconMap.set('check-circle', CheckCircleIcon);
IconMap.set('check', CheckIcon);
IconMap.set('more-vert', MoreVertIcon);
IconMap.set('organization', BusinessIcon);
IconMap.set('network-error', WarningAmberIcon);
IconMap.set('deny', DoNotDisturbIcon);
IconMap.set('download', DownloadIcon);
IconMap.set('link', LinkIcon);
IconMap.set('assignment', AssignmentIcon);
IconMap.set('time-lapse', TimelapseIcon);
IconMap.set('lock-clock', LockClockIcon);
IconMap.set('doc-search', DocumentScannerIcon);
IconMap.set('select-all', SelectAll);
IconMap.set('question-mark', QuestionMarkIcon);
IconMap.set('arrow-double-up', KeyboardDoubleArrowUpIcon);
IconMap.set('arrow-double-down', KeyboardDoubleArrowDownIcon);
IconMap.set('expand', ExpandMoreIcon);
IconMap.set('collapse', ExpandLessIcon);
IconMap.set('upload', FileUploadIcon);
IconMap.set('image', ImageIcon);
IconMap.set('vector', CallMadeIcon);
IconMap.set('cloudsync', CloudSyncIcon);
IconMap.set('assume-role', AdminPanelSettingsIcon);
IconMap.set('receipt', ReceiptIcon);
IconMap.set('partner', ApartmentIcon);
IconMap.set('export', DownloadingIcon);
IconMap.set('more-horiz', MoreHorizIcon);
IconMap.set('magic-link', MailLockIcon);
IconMap.set('plug', SettingsInputCompositeIcon);
IconMap.set('certificate', BadgeIcon);
IconMap.set('open-in-new', OpenInNewIcon);

export type IconColor = 'white' | 'black' | 'grey' | 'active' | 'success' | 'error' | 'link';
type IconFontSizeLabel = 'small' | 'medium' | 'large';

export const getSizeProp = (
  size: string
): { fontSize: IconFontSizeLabel } | { sx: { fontSize: number } } => {
  if (['small', 'medium', 'large'].includes(size)) {
    return { fontSize: size as IconFontSizeLabel };
  }

  switch (size) {
    case 'x-small':
      return { sx: { fontSize: 14 } };
    case 'x-large':
      return { sx: { fontSize: 80 } };
  }

  return { fontSize: 'medium' };
};
